export default __webpack_public_path__ + "static/media/Matutino.ca8c6149.png";